module.exports = __webpack_public_path__ + "img/bixi.8cd4b151.png";